module.exports = __webpack_public_path__ + "img/rc-back.45ea4f5c.png";